export enum EntityAutocompleteType {
  Includes = 'includes',
  StartWith = 'startWith',
}
